import { Text } from '@chakra-ui/react';
import TextSection from '@components/articles/SeoTextSection';
import Body1 from '@components/typography/Body1';
import { fontSize } from '@constants/styles';
import Plans from './common/Plans';

const PlanG = ({ name, carriers, renderCta }) => {
  return (
    <>
      <TextSection title={`Top 10 Lowest Cost Plan G Options in ${name}:`}>
        <Body1 fontSize={fontSize.p}>
          {`Here are the top five lowest cost options for Plan G in ${name}. These assume you are 65, don’t smoke, and are female. Contact us for precise quotes.`}
        </Body1>
        <Plans plans={carriers} />
        <Text fontSize={fontSize.p}>
          Premiums do vary by zip code, so contact us below to hear the local premiums you can actually enroll in.
        </Text>
        {renderCta()}
      </TextSection>
    </>
  );
};

export default PlanG;
